import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CloseRfqOpt from './CloseRfqOpt';
import StaticPopupNew from 'components/StaticPopupNew';



const MoreOptions = ({ index, rfqData, allSuppliers, userProfile, openPdfForSupplier, onExcludeFromComparison, onRequestQuotationUpdate }) => {

    const [openDropdown, setOpenDropdown] = useState(null);
    const [openHistory, setOpenHistory] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isClosedRfq, setIsClosedRfq] = useState(false);
    const [isPurchaseOrderOpen, setIsPurchaseOrderOpen] = useState(false);
    const [isVendorFilesPopupOpen, setIsVendorFilesPopupOpen] = useState(false);
    const [vendorAttachments, setVendorAttachments] = useState([]);
    const [isExcludePopupOpen, setIsExcludePopupOpen] = useState(false);
    const [excludeReason, setExcludeReason] = useState("");
    const [excludeReasonError, setExcludeReasonError] = useState("");
    const [excludeSubmitting, setExcludeSubmitting] = useState(false);
    const [requestUpdateSubmitting, setRequestUpdateSubmitting] = useState(false);
    const [isRequestUpdatePopupOpen, setIsRequestUpdatePopupOpen] = useState(false);
    const [requestUpdateMessage, setRequestUpdateMessage] = useState("");

    const isRfqClosed = (rfqData?.status === "CLOSED" || rfqData?.status === "PENDING APPROVAL");
    const canChangeComparisonVendors = ["OPEN", "REWORK"].includes(String(rfqData?.status || "").toUpperCase());
    const activeQuotedSupplierCount = (allSuppliers || []).filter((supplier) =>
        supplier?.quotationReceived && supplier?.exclusionDetails?.isExcludedFromComparison !== true
    ).length;
    const canExcludeFromComparison =
        canChangeComparisonVendors &&
        rfqData?.suppliers?.[0]?.quotationReceived &&
        rfqData?.suppliers?.[0]?.exclusionDetails?.isExcludedFromComparison !== true &&
        activeQuotedSupplierCount > 1;
    const supplier = rfqData?.suppliers?.[0];
    const canRequestQuotationUpdate =
        String(rfqData?.status || "").toUpperCase() === "PENDING APPROVAL" &&
        supplier?.quotationReceived === true &&
        supplier?.exclusionDetails?.isExcludedFromComparison !== true &&
        supplier?.quotationUpdateRequest?.isRequested !== true;
    const latestQuotationSet = rfqData?.suppliers[0]?.vendorQuotations?.quotationSets.slice(-1)[0];
    const quotationSets = Array.isArray(supplier?.vendorQuotations?.quotationSets)
        ? supplier.vendorQuotations.quotationSets
        : [];
    const getQuotationTotal = (quotation) =>
        Number(quotation?.totalWithoutGst || 0) + Number(quotation?.othersTotalWithoutGst || 0);
    const hasAmountChanged = (quotation, previousQuotation) =>
        Math.abs(getQuotationTotal(quotation) - getQuotationTotal(previousQuotation)) > 0.01;
    const changedQuotationSets = quotationSets.reduce((changedSets, quotation, quotationIndex) => {
        if (quotationIndex === 0 || hasAmountChanged(quotation, quotationSets[quotationIndex - 1])) {
            changedSets.push({ item: quotation, index: quotationIndex });
        }
        return changedSets;
    }, []);
    const revisionCount = Math.max(changedQuotationSets.length - 1, 0);
    const negotiationPanelWidth = {
        contractor: "w-[620px]",
        labour: "w-[540px]",
        material: "w-[480px]",
    }[String(rfqData?.rfqType || "").toLowerCase()] || "w-[480px]";
    const dropdownRef = useRef(null);
    const mainMenuRef = useRef(null);
    const historyMenuRef = useRef(null);
    const [menuLeftClip, setMenuLeftClip] = useState({ main: 0, history: 0 });
    const navigate = useNavigate()



    const hasApprovalFlowFeature = userProfile?.userEntity?.features?.some(
        feature => feature.featureName === "APPROVAL_FLOW" && feature.hasFeature
    );

    const isPoFeatureUnable = userProfile?.userEntity?.features?.some(feature => feature.featureName === "PO_GENERATION" && feature.hasFeature);


    const closeModal = () => {
        setIsModalOpen(!isClosedRfq);
    };
    const handleOpenModal = () => {
        setIsClosedRfq(true);
    };

    const handleCloseModal = () => {
        setIsClosedRfq(false);
    };

    const handleGeneratePO = () => {
        navigate(`/create-po?rfqId=${rfqData?.rfqId}&isEdit=false`, { state: { rfqData } });
    };

    const handleOpenRfqTimeline = () => {
        navigate(`/rfqs/${rfqData?.rfqId}/timeline`, { state: { rfqData } });
    };

    const handleClosePurchaseOrder = () => {
        setIsPurchaseOrderOpen(false);
    };


    const navigateToEditRfq = () => {
        switch (rfqData?.rfqType) {
            case "material":
                navigate(`/material-form?rfqId=${rfqData?.rfqId}&isEdit=true&rfqType=${rfqData?.rfqType}`, { state: { rfqData: rfqData, isEdit: true } });
                break;

            case "labour":
                navigate(`/labour-form?rfqId=${rfqData?.rfqId}&isEdit=true&rfqType=${rfqData?.rfqType}`, { state: { rfqData: rfqData, isEdit: true } })
                break;

            case "contractor":
                navigate(`/providing-form?rfqId=${rfqData?.rfqId}&isEdit=true&rfqType=${rfqData?.rfqType}`, { state: { rfqData: rfqData, isEdit: true } })
                break;
        }
    }

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdown(null);
                setOpenHistory(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useLayoutEffect(() => {
        if (openDropdown !== index) {
            setMenuLeftClip({ main: 0, history: 0 });
            return undefined;
        }

        const updateLeftClip = () => {
            const table = dropdownRef.current?.closest(".comparison-table");
            const fixedColumn = table?.querySelector("thead th.fixed-column");
            const stickyBoundary = fixedColumn?.getBoundingClientRect().right || 0;
            const getOverlap = (element) => {
                if (!element || stickyBoundary <= 0) return 0;
                const rect = element.getBoundingClientRect();
                return Math.max(0, Math.min(rect.width, stickyBoundary - rect.left));
            };

            setMenuLeftClip({
                main: getOverlap(mainMenuRef.current),
                history: getOverlap(historyMenuRef.current),
            });
        };

        const animationFrameId = window.requestAnimationFrame(updateLeftClip);
        const scrollContainer = dropdownRef.current?.closest(".comparison-scrollbar");
        scrollContainer?.addEventListener("scroll", updateLeftClip);
        window.addEventListener("resize", updateLeftClip);

        return () => {
            window.cancelAnimationFrame(animationFrameId);
            scrollContainer?.removeEventListener("scroll", updateLeftClip);
            window.removeEventListener("resize", updateLeftClip);
        };
    }, [index, openDropdown, openHistory]);

    const handleDropdown = (index) => {
        if (openDropdown === index) {
            setOpenDropdown(null);
        } else {
            setOpenDropdown(index);
            setOpenHistory(false); // Close history when main dropdown opens
        }
    }

    const handleHistory = () => {
        setOpenHistory(!openHistory);
    }


    const handleRequestQuotationUpdate = () => {
        if (!canRequestQuotationUpdate || requestUpdateSubmitting) return;
        setOpenDropdown(null);
        setRequestUpdateMessage("");
        setIsRequestUpdatePopupOpen(true);
    };

    const handleCloseRequestUpdatePopup = () => {
        if (requestUpdateSubmitting) return;
        setIsRequestUpdatePopupOpen(false);
        setRequestUpdateMessage("");
    };

    const handleConfirmRequestQuotationUpdate = async () => {
        if (!canRequestQuotationUpdate || requestUpdateSubmitting) return;
        setRequestUpdateSubmitting(true);
        try {
            await onRequestQuotationUpdate?.(supplier, requestUpdateMessage.trim());
            setIsRequestUpdatePopupOpen(false);
            setRequestUpdateMessage("");
        } finally {
            setRequestUpdateSubmitting(false);
        }
    };
    const handleExcludeFromComparison = () => {
        setOpenDropdown(null);
        setExcludeReason("");
        setExcludeReasonError("");
        setIsExcludePopupOpen(true);
    };

    const handleCloseExcludePopup = () => {
        if (excludeSubmitting) return;
        setIsExcludePopupOpen(false);
        setExcludeReason("");
        setExcludeReasonError("");
    };

    const handleSubmitExclude = async () => {
        const trimmedReason = excludeReason.trim();
        if (!trimmedReason) {
            setExcludeReasonError("Reason is required");
            return;
        }

        setExcludeSubmitting(true);
        try {
            await onExcludeFromComparison?.(rfqData?.suppliers?.[0], trimmedReason);
            handleCloseExcludePopup();
        } catch (error) {
            // Snackbar is handled by the caller; keep the popup open for correction/retry.
        } finally {
            setExcludeSubmitting(false);
        }
    };
    const handleOpenVendorFilesPopup = () => {
        const latestQuotationSet = rfqData?.suppliers[0]?.vendorQuotations?.quotationSets.slice(-1)[0];
        if (latestQuotationSet) {
            setVendorAttachments(latestQuotationSet.attachments);
            setIsVendorFilesPopupOpen(true);
        }
    };

    const handleCloseVendorFilesPopup = () => {
        setIsVendorFilesPopupOpen(false);
        setVendorAttachments([]);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true };
        return date.toLocaleString('en-US', options);
    };

    const renderVersionHistory = () => {
        const quotations = rfqData?.suppliers[0]?.vendorQuotations?.quotationSets || [];

        if (quotations.length === 0) return null; // If no quotations exist, don't render anything.

        const handleQuotationSetClick = (index) => {
            // Check if rfqType is available
            if (!rfqData?.rfqType) {
                console.error("RFQ type is not defined");
                return;
            }

            // Navigate based on rfqType and include the quotationSet index
            switch (rfqData.rfqType) {
                case "material":
                    navigate(`/material-form?rfqId=${rfqData?.rfqId}&quotationIndex=${index}&readOnly=true&rfqType=${rfqData?.rfqType}`, {
                        state: { rfqData, quotationIndex: index, isEdit: true }
                    });
                    break;

                case "labour":
                    navigate(`/labour-form?rfqId=${rfqData?.rfqId}&quotationIndex=${index}&readOnly=true&rfqType=${rfqData?.rfqType}`, {
                        state: { rfqData, quotationIndex: index, isEdit: true }
                    });
                    break;

                case "contractor":
                    navigate(`/providing-form?rfqId=${rfqData?.rfqId}&quotationIndex=${index}&readOnly=true&rfqType=${rfqData?.rfqType}`, {
                        state: { rfqData, quotationIndex: index, isEdit: true }
                    });
                    break;

                default:
                    console.error("Invalid RFQ type");
            }
        };


        const formatAmount = (amount) => new Intl.NumberFormat("en-IN", {
            maximumFractionDigits: 2,
        }).format(Number(amount || 0));
        const firstQuotationTotal = getQuotationTotal(quotations[0]);
        const currentQuotationTotal = getQuotationTotal(quotations[quotations.length - 1]);
        const savedAmount = firstQuotationTotal - currentQuotationTotal;
        const savedPercentage = firstQuotationTotal
            ? ((savedAmount / firstQuotationTotal) * 100).toFixed(2)
            : "0.00";
        const vendorSource = supplier?.vendorSource === "MARKETPLACE"
            ? "Marketplace"
            : supplier?.vendorSource === "INTERNAL"
                ? "Internal"
                : supplier?.vendorSource || "-";
        const vendorRank = supplier?.vendorQuotations?.rank || "-";

        return (
            <>
                <li className="border-b border-[#E7E7DD] px-2 pb-2">
                    <div className="flex items-start justify-between gap-2">
                        <div className="min-w-0 text-left">
                            <p className="text-[9px] font-semibold uppercase tracking-[0.12em] text-[#6F6F68]">Negotiation history</p>
                            <p className="truncate text-xs font-semibold text-[#2D2D11]">
                                {supplier?.businessName || "Vendor"}
                                <span className="font-normal text-[#6F6F68]"> | {vendorRank} | {vendorSource}</span>
                            </p>
                        </div>
                        <button
                            type="button"
                            aria-label="Close negotiation history"
                            onClick={() => setOpenHistory(false)}
                            className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md border border-[#D8D8CC] text-sm leading-none text-[#434343] transition-colors hover:bg-[#F8F8F3]"
                        >
                            x
                        </button>
                    </div>

                    <div className="mt-2 grid grid-cols-3 gap-1.5 text-left">
                        <div className="rounded-md bg-[#F3F4F7] px-2 py-1.5">
                            <p className="text-[9px] text-[#6F6F68]">First quote</p>
                            <p className="mt-0.5 text-[11px] font-semibold text-[#2D2D11]">{formatAmount(firstQuotationTotal)}</p>
                        </div>
                        <div className="rounded-md bg-[#F3F4F7] px-2 py-1.5">
                            <p className="text-[9px] text-[#6F6F68]">Current (R{quotations.length - 1})</p>
                            <p className="mt-0.5 text-[11px] font-semibold text-[#2D2D11]">{formatAmount(currentQuotationTotal)}</p>
                        </div>
                        <div className={`rounded-md px-2 py-1.5 ${savedAmount >= 0 ? "bg-[#EAF5ED]" : "bg-[#FFF1F1]"}`}>
                            <p className="text-[9px] text-[#6F6F68]">Saved</p>
                            <p className={`mt-0.5 text-[11px] font-semibold ${savedAmount >= 0 ? "text-[#167A45]" : "text-[#DC2626]"}`}>
                                {formatAmount(Math.abs(savedAmount))} | {savedAmount >= 0 ? "" : "-"}{Math.abs(Number(savedPercentage))}%
                            </p>
                        </div>
                    </div>

                    <div className="mt-2 flex items-center gap-2">
                        <div className="flex min-w-0 flex-1 gap-1">
                            {changedQuotationSets.map(({ index: quotationIndex }) => (
                                <span
                                    key={quotationIndex}
                                    className={`h-1 flex-1 rounded-full ${quotationIndex === changedQuotationSets[changedQuotationSets.length - 1]?.index ? "bg-[#E85D2A]" : "bg-[#2D2D11]"}`}
                                />
                            ))}
                        </div>
                        <span className="whitespace-nowrap text-[9px] text-[#6F6F68]">
                           {changedQuotationSets.length} rounds
                        </span>
                    </div>
                </li>

                <li className="flex items-center justify-between border-b border-[#E7E7DD] px-2 py-2 text-left">
                    <div className="flex items-center gap-2">
                        <span className="rounded-md border border-[#E7E7DD] px-1.5 py-0.5 text-[9px] text-[#6F6F68]">
                            Compare R0 vs R{quotations.length - 1}
                        </span>
                        <span className="text-[10px] font-semibold text-[#2D2D11]">RFQ Timeline</span>
                    </div>
                </li>

                {[...changedQuotationSets].reverse().map(({ item, index }, reverseIndex) => {
                    const isOriginal = index === 0;
                    const isLatest = reverseIndex === 0;
                    const quotationUpdateReason = item?.quotationUpdateReason;
                    const quotationRemark = typeof quotationUpdateReason === "string"
                        ? quotationUpdateReason
                        : quotationUpdateReason?.remark || quotationUpdateReason?.reason;
                    const prevQuotation = quotations[index - 1];
                    const prevTotal = getQuotationTotal(prevQuotation);
                    const itemTotal = getQuotationTotal(item);
                    const priceDifference = prevQuotation ? prevTotal - itemTotal : 0;
                    const priceDifferencePercent = prevQuotation && prevTotal
                        ? ((priceDifference / prevTotal) * 100).toFixed(2)
                        : "0.00";
                    const differenceDisplay = !isOriginal
                        ? `${priceDifference > 0 ? "-" : "+"}${formatAmount(Math.abs(priceDifference))} (${priceDifference > 0 ? "-" : "+"}${Math.abs(Number(priceDifferencePercent))}%)`
                        : "";
                    const versionLabel = isOriginal ? "Original quotation" : `Revision ${index}`;

                    return (
                        <React.Fragment key={index}>
                            <li
                                className="relative cursor-pointer border-b border-[#E7E7DD] px-2 py-2.5 text-left transition-colors hover:bg-[#F8F8F3]"
                                onClick={() => handleQuotationSetClick(index)}
                            >
                                <span className={`absolute left-0 top-3 flex h-4 w-4 items-center justify-center rounded-full text-[8px] font-bold text-white ${isLatest ? "bg-[#C2410C]" : "bg-[#1F2937]"}`}>
                                    {isOriginal ? "R0" : `R${index}`}
                                </span>
                                <div className="pl-6">
                                    <div className="flex items-start justify-between gap-2">
                                        <div className="min-w-0">
                                            <p className="text-[10px] font-semibold text-[#2D2D11]">
                                                {isLatest ? "Current" : versionLabel}
                                                <span className="ml-1 font-normal text-[#6F6F68]">· {formatDate(item.submittedAt)}</span>
                                            </p>
                                            <p className="text-[9px] text-[#6F6F68]">By {item.submittedBy || "-"}</p>
                                        </div>
                                        <p className="whitespace-nowrap text-[10px] font-semibold text-[#2D2D11]">
                                            {formatAmount(itemTotal)}
                                            {!isOriginal && (
                                                <span className={`ml-1 text-[9px] ${priceDifference > 0 ? "text-[#167A45]" : "text-[#DC2626]"}`}>
                                                    {differenceDisplay}
                                                </span>
                                            )}
                                        </p>
                                    </div>
                                    {!isOriginal && (
                                        <span className={`mt-1 inline-flex rounded-sm px-1.5 py-0.5 text-[8px] ${priceDifference > 0 ? "bg-[#EAF5ED] text-[#167A45]" : "bg-[#FFF1F1] text-[#DC2626]"}`}>
                                            {priceDifference > 0 ? "Rate reduced" : "Rate increased"}
                                        </span>
                                    )}
                                    {quotationRemark && (
                                        <p className="mt-1 rounded-md border border-[#E7E7DD] bg-[#FAFAF8] px-2 py-1.5 text-[9px] leading-4 text-[#5F6F8A]">
                                            {quotationRemark}
                                        </p>
                                    )}
                                </div>
                            </li>
                        </React.Fragment>
                    );
                })}
            </>
        );
    };





    const renderAttachments = () => {
        return vendorAttachments.map((attachment, index) => {
            const lastIndex = attachment.Name.lastIndexOf('.'); // Extract file extension
            const path = lastIndex !== -1 ? attachment.Name.substring(lastIndex + 1) : null;
            return (
                <div key={index} className="flex justify-between items-center mx-2 mt-2 ">
                    <div className="mb-2 px-2 flex w-fit items-center justify-center border border-[#8E8E85] rounded-full py-1 space-x-2 text-[#434343]">
                        <img src={`/assets/icons/${path}.png`} alt={path} className="h-5 w-5" />
                        <a
                            href={attachment.Content}
                            target="_blank"
                            rel="noopener noreferrer"
                            download={attachment.Name}
                            className="text-xs text-[#434343] hover:underline"
                        >
                            {attachment.Name}
                        </a>
                    </div>
                </div>
            );
        });
    };

    return (
        <div ref={dropdownRef} className='relative'>
            {requestUpdateSubmitting && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[2px]">
                    <div className="min-w-[300px] rounded-2xl border border-blue-100 bg-white px-6 py-5 shadow-2xl">
                        <div className="flex items-center gap-4">
                            <div className="relative h-11 w-11">
                                <div className="absolute inset-0 rounded-full border-4 border-blue-100"></div>
                                <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 animate-spin"></div>
                                <div className="absolute inset-[10px] rounded-full bg-blue-50"></div>
                            </div>
                            <div>
                                <p className="text-sm font-semibold text-[#1F1E29]">Requesting quotation update</p>
                                <p className="mt-1 text-xs text-gray-500">Sending email and WhatsApp notification to the vendor...</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* dropdown button */}
            <div className="relative inline-flex">
                <div onClick={() => handleDropdown(index)} className={`cursor-pointer rounded-lg border border-[#D8D8CC] bg-white shadow-sm w-7 h-7 flex justify-center items-center my-2
                     ${openDropdown === index ? 'rotate-180 ' : ''}`}>
                    <img
                        src="https://storagereponeevaydevcdn.blob.core.windows.net/business/searchbar_arrow.svg"
                        alt=""
                        className="h-2.5 w-2.5"
                    />
                </div>
                {revisionCount > 0 && (
                    <button
                        type="button"
                        onClick={(event) => {
                            event.stopPropagation();
                            setOpenDropdown(index);
                            setOpenHistory(true);
                        }}
                        className="absolute -right-2 -top-2 z-10 inline-flex min-h-[16px] min-w-[16px] cursor-pointer items-center justify-center rounded-full bg-[#DC2626] px-1 text-[9px] font-bold leading-none text-white shadow-sm transition hover:bg-[#B91C1C] focus:outline-none focus:ring-2 focus:ring-red-200"
                        aria-label={`${revisionCount} quotation ${revisionCount === 1 ? "revision" : "revisions"}`}
                        title="Open revision history"
                    >
                        {revisionCount}
                    </button>
                )}
            </div>
            {/* dropdown */}
            {openDropdown === index && (
                <div className='absolute right-0 top-full z-20 mt-1 w-[220px] max-w-[calc(100vw-1rem)]'>
                    {openHistory && (
                        <ul
                            ref={historyMenuRef}
                            className={`absolute right-0 top-full z-30 mt-2 max-h-[360px] ${negotiationPanelWidth} max-w-[calc(100vw-1rem)] overflow-y-auto rounded-xl border border-[#E7E7DD] bg-white p-1.5 text-xs text-[#6F6F68] shadow-[0_16px_40px_rgba(45,45,17,0.18)]`}
                            style={{ clipPath: `inset(0 0 0 ${menuLeftClip.history}px)` }}
                        >

                            {renderVersionHistory()}
                        </ul>
                    )}

                    <ul
                        ref={mainMenuRef}
                        className='rounded-xl border border-[#E7E7DD] bg-white p-1 text-xs shadow-[0_12px_30px_rgba(45,45,17,0.16)]'
                        style={{ clipPath: `inset(0 0 0 ${menuLeftClip.main}px)` }}
                    >
                        {!isRfqClosed && <li
                            onClick={navigateToEditRfq}
                            className='group flex min-h-[36px] items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'
                        >
                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#F8F8F3]">
                                <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/bid_levelling_pencil.svg" alt="" className='h-4 w-4' />
                            </span>
                            <span className='w-full text-left font-medium text-[#2D2D11] cursor-pointer'>Edit Quote</span>
                            {/* <button className='right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-[#A6A6A6]'>
                                ✕
                            </button> */}
                        </li>}

                        {rfqData?.suppliers[0]?.isAwarded && rfqData?.rfqType === "material" && rfqData?.status === "CLOSED" && isPoFeatureUnable && <li onClick={handleGeneratePO} className='group flex min-h-[36px] items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'>
                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#F8F8F3]">
                                <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/PO_creation.png" alt="" className='h-4 w-4' />
                            </span>
                            <span className='w-full text-left font-medium text-[#2D2D11] cursor-pointer'>Create PO</span>
                        </li>}


                        {canRequestQuotationUpdate && (
                            <li onClick={handleRequestQuotationUpdate} className='group flex min-h-[36px] items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'>
                                <span className='flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#FFF4EC] text-[12px] font-semibold text-[#E85D2A]'>?</span>
                                <span className='w-full text-left font-medium text-[#2D2D11] cursor-pointer'>
                                    {requestUpdateSubmitting ? "Requesting..." : "Request Quotation Update"}
                                </span>
                            </li>
                        )}
                        {/* New Export PDF Button */}
                        {rfqData?.suppliers[0]?.quotationReceived && (
                            <li onClick={() => {
                                if (openPdfForSupplier) {
                                    openPdfForSupplier(rfqData.suppliers[0]);
                                }
                            }} className='group flex min-h-[36px] items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'>
                                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#F8F8F3]">
                                    <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/rfqPdf.svg" alt="" className="h-4 w-4" />
                                </span>
                                <span className='w-full text-left font-medium text-[#2D2D11] cursor-pointer'>Export PDF</span>
                            </li>
                        )}

                        {/* {!isRfqClosed && < li
                            onClick={handleOpenModal}
                            className='flex items-center px-3 space-x-4 py-2 relative group bg-white hover:bg-[#F5F5F3]'
                        >
                            <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/bid_leveling_soft_award.svg" alt="" className='w-4 h-4' />
                            <span className='w-full text-left text-[#3C3C3C] font-normal cursor-pointer'>{hasApprovalFlowFeature ? 'Send for Approval' : 'Close RFQ'}</span>
                            <button className='right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-[#A6A6A6]'>
                                ✕
                            </button>
                        </li>} */}

                        {canExcludeFromComparison && (
                            <li onClick={handleExcludeFromComparison} className='group flex min-h-[36px] items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'>
                                <span className='flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#FFF1F1] text-[12px] font-semibold text-[#DC2626]'>!</span>
                                <span className='w-full text-left font-medium text-[#2D2D11] cursor-pointer'>Exclude from Comparison</span>
                            </li>
                        )}
                        {latestQuotationSet?.attachments?.length > 0 && <li onClick={handleOpenVendorFilesPopup} className='group flex min-h-[36px] items-center gap-2 rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'>
                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#F8F8F3]">
                                <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/files.svg" alt="" className='h-4 w-4' />
                            </span>
                            <span className='w-full text-left font-medium text-[#2D2D11] cursor-pointer'>Vendor Files</span>
                            {/* <button className='right-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-[#A6A6A6]'>
                                ✕
                            </button> */}
                        </li>}

                        {/* <li onClick={handleOpenRfqTimeline} className='flex items-center px-3 space-x-4 py-2 relative group bg-white hover:bg-[#F5F5F3]'>
                            <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/clock_rotate_left.svg" alt="timeline" className='w-4 h-4' />
                            <span className='w-full text-left text-[#3C3C3C] font-normal cursor-pointer'>RFQ Timeline</span>
                        </li> */}

                        <li onClick={handleHistory} className='group flex min-h-[36px] cursor-pointer items-center justify-between rounded-lg px-2 py-2 transition-colors hover:bg-[#F8F8F3]'>
                            <div className='flex items-center gap-2'>
                                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-[#F8F8F3]">
                                    <img src="https://storagereponeevaydevcdn.blob.core.windows.net/business/clock_rotate_left.svg" alt="svg" className="h-4 w-4" />
                                </span>
                                <span className='text-left font-medium text-[#2D2D11] cursor-pointer'>Revision History</span>
                                {revisionCount > 0 && (
                                    <span
                                        className="inline-flex min-h-[16px] min-w-[16px] items-center justify-center rounded-full bg-[#DC2626] px-1 text-[9px] font-bold leading-none text-white"
                                        aria-label={`${revisionCount} quotation ${revisionCount === 1 ? "revision" : "revisions"}`}
                                    >
                                        {revisionCount}
                                    </span>
                                )}
                            </div>
                            <img
                                src="https://storagereponeevaydevcdn.blob.core.windows.net/business/searchbar_arrow.svg"
                                alt=""
                                className={`transition-transform duration-300 h-2 w-2 ${openHistory ? 'rotate-180' : ''}`}
                            />
                        </li>
                    </ul>

                </div>
            )
            }


            {/* Vendor Files Popup */}
            {
                isVendorFilesPopupOpen && (
                    <StaticPopupNew header={"Vendor Files"} bodyStyle={`pb-0 pt-0`} openModal={isVendorFilesPopupOpen} handleClose={handleCloseVendorFilesPopup}>
                        <div className="px-4 py-2">
                            <h3 className="text-xs font-semibold text-[#434343]">Attachments</h3>
                            <div className="space-y-2">
                                {renderAttachments()}
                            </div>
                        </div>
                    </StaticPopupNew>
                )
            }


            {isExcludePopupOpen && (
                <StaticPopupNew header={"Exclude from Comparison"} bodyStyle={`pb-0 pt-0`} openModal={isExcludePopupOpen} handleClose={handleCloseExcludePopup}>
                    <div className="px-4 py-3 space-y-3">
                        <div>
                            <p className="text-sm font-medium text-[#2D2D11]">{rfqData?.suppliers?.[0]?.businessName || "Vendor"}</p>
                            <p className="text-xs text-gray-500">Please add a reason before excluding this vendor from active comparison.</p>
                        </div>
                        <textarea
                            value={excludeReason}
                            onChange={(event) => {
                                setExcludeReason(event.target.value);
                                if (excludeReasonError) setExcludeReasonError("");
                            }}
                            rows={4}
                            className="w-full resize-none rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#1F1E29]"
                            placeholder="Enter reason / remark"
                        />
                        {excludeReasonError && <p className="text-xs text-red-600">{excludeReasonError}</p>}
                        <div className="flex justify-end gap-2 border-t border-gray-100 pt-3">
                            <button type="button" onClick={handleCloseExcludePopup} disabled={excludeSubmitting} className="px-4 py-2 text-xs border border-gray-300 rounded-md text-gray-700 disabled:opacity-60">
                                Cancel
                            </button>
                            <button type="button" onClick={handleSubmitExclude} disabled={excludeSubmitting} className="px-4 py-2 text-xs rounded-md bg-[#1F1E29] text-white disabled:opacity-60">
                                {excludeSubmitting ? "Excluding..." : "Submit & Exclude"}
                            </button>
                        </div>
                    </div>
                </StaticPopupNew>
            )}
            {isRequestUpdatePopupOpen && (
                <StaticPopupNew header={"Request Quotation Update"} bodyStyle={`pb-0 pt-0`} openModal={isRequestUpdatePopupOpen} handleClose={handleCloseRequestUpdatePopup}>
                    <div className="px-4 py-3 space-y-3">
                        <div>
                            <p className="text-sm font-medium text-[#2D2D11]">{supplier?.businessName || "Vendor"}</p>
                            <p className="text-xs text-gray-500">
                                Note: this message will be sent in the mail and WhatsApp communication message.
                            </p>
                        </div>
                        <label className="block text-xs font-semibold text-[#4F4F45]">
                            Message from {userProfile?.name || "Manager"}
                        </label>
                        <textarea
                            value={requestUpdateMessage}
                            onChange={(event) => setRequestUpdateMessage(event.target.value)}
                            rows={4}
                            className="w-full resize-none rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-[#1F1E29]"
                            placeholder="Add message for the vendor"
                        />
                        <div className="flex justify-end gap-2 border-t border-gray-100 pt-3">
                            <button type="button" onClick={handleCloseRequestUpdatePopup} disabled={requestUpdateSubmitting} className="px-4 py-2 text-xs border border-gray-300 rounded-md text-gray-700 disabled:opacity-60">
                                Cancel
                            </button>
                            <button type="button" onClick={handleConfirmRequestQuotationUpdate} disabled={requestUpdateSubmitting} className="px-4 py-2 text-xs rounded-md bg-[#1F1E29] text-white disabled:opacity-60">
                                {requestUpdateSubmitting ? "Requesting..." : "Send Request"}
                            </button>
                        </div>
                    </div>
                </StaticPopupNew>
            )}
            {
                isClosedRfq && (
                    <StaticPopupNew header={"Close RFQ"} bodyStyle={`pb-0 pt-0`} openModal={isClosedRfq} handleClose={handleCloseModal}>
                        <CloseRfqOpt closeModal={handleCloseModal} selectedSupplier={rfqData?.suppliers[0]} allSuppliers={allSuppliers} rfqId={rfqData?.rfqId} entityId={rfqData?.entityId} isApprovalRequired={hasApprovalFlowFeature} />
                    </StaticPopupNew>
                )
            }

        </div >
    );
};

export default MoreOptions;
